import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import firebase from 'firebase/app';

import { AngularFirestore } from '@angular/fire/firestore';
import { AuthorizationService } from '../authorization/authorization.service';
import { OrderInterface, OrderInterfaceWithId} from '@sk/sk-interfaces';


@Injectable({
  providedIn: 'root'
})
export class WorkOrdersService {

  constructor(private af: AngularFirestore,
              private authService: AuthorizationService) {
  }


  getOrders(fromDate: Date): Observable<OrderInterfaceWithId[]> {
    return this.authService.getCurrentAuth()
      .pipe(
        switchMap(currentUser => {
          if(!currentUser){
            return [];
          }
          return this.af.collection('organizations').doc(currentUser.organizationId)
            .collection('orders', ref => ref
              .where('technicianId', '==', currentUser.organizationUid)
              .where('orderDate', '>=', fromDate)
              .where('active', '==', true)
            )
            .snapshotChanges()
        }),
        map(actions => actions
          .map(a => {
            const data = a.payload.doc.data() as OrderInterface;
            const exists = a.payload.doc.exists;
            const id = a.payload.doc.id;
            return { id, exists, ...data } as OrderInterfaceWithId;
          })
        )
      );
  }

  getOrder(id: string): Observable<firebase.firestore.DocumentSnapshot> {
    return this.authService.getCurrentAuth()
      .pipe(
        switchMap(currentUser => this.af.collection('organizations')
        .doc(currentUser.organizationId)
        .collection('orders').doc(id).get()));
  }



  /**
   *
   * @param order
   */
  updateOrder(order: OrderInterfaceWithId) {
    const updateOrder : OrderInterfaceWithId = {
      lastUpdated : firebase.firestore.Timestamp.fromDate(new Date()),
      ...order,
    }

    delete updateOrder.id;

    return this.authService.getCurrentAuth()
      .pipe(
        switchMap(auth => this.af.collection('organizations').doc(auth.organizationId)
          .collection('orders').doc(order.id).update(updateOrder))
      );
  }




}
